import { EnvironmentInterface } from '../../interfaces/environment/environment-interface';
import { DefaultsModel } from '../defaults/defaults-model';
import { I18nModel } from '../i18n/i18n-model';
import { ScriptsModel } from '../scripts/scripts-model';
import { PlatformEnum } from '@fh-client-interaction-frontends/fh-enums';
import { SupportEnvironmentModel } from '../support/support-environment-model';

export class EnvironmentModel implements EnvironmentInterface {
  IBANPrefix: string[] = new Array<string>();
  api: string = '';
  apiAppContext: string ='';
  apiPartnershipId: string = '';
  apiPartnershipIdLink?: string = '';
  appVersion: number = -1;
  baseUrl: string = '';
  colorPrimary: string = '';
  colorPrimaryTint?: string = '';
  cpBaseUrl: string = '';
  currencyCode: string = '';
  defaults: DefaultsModel = new DefaultsModel();
  i18n: I18nModel = new I18nModel();
  support: SupportEnvironmentModel = new SupportEnvironmentModel();
  locale: string = '';
  maxAge: number = -1;
  maxContractStartDay: number = -1;
  maxContractStartDaysRange: number = -1;
  platform: PlatformEnum = PlatformEnum.salesPortal;
  onlyMedicalNetwork: boolean = false;
  production: boolean = false;
  scripts: ScriptsModel = new ScriptsModel();
  tableMobileBreakpoint: string = '';
  externalApps: object[] = new Array<object>();
  icon: string = '';
  apiUsername?: string = '';
  apiPassword?: string = '';
  debounceDelay: number = -1;
  fhvcHandonUrl: string = '';
  partnershipName: string = '';
  brandName: string = '';
  toastrDuration: number = 5000;
  faqsUrl: string = '';

  constructor(init?: Partial<EnvironmentModel>) {
    Object.assign(this, init);
  }
}
